/* ============================================================================
   DEV AASTHA — PDP V2 · JUDGE.ME BRIDGE
   ----------------------------------------------------------------------------
   Reviews do jagah dikh rahe the: hamara section (seeded cards) aur Judge.me ka
   apna widget. Owner ko EK chahiye — hamare mockup format me, par data asli
   Judge.me se.

   Judge.me single reviews Liquid ko deta hi nahi (sirf rating + rating_count
   metafields aate hain). Asli reviews sirf uske widget ke DOM me hote hain.
   Isliye ye bridge:

     1. Judge.me widget ko chhupa deta hai (DOM me rehne deta hai — uska JS,
        uska form aur uska review JSON-LD sab wahin chalte rehte hain)
     2. `.jdgm-rev` se asli data padhta hai
     3. usse mockup ke `.rev` markup me dobara render karta hai
     4. "Write a review" button ko Judge.me ke apne link par forward karta hai

   ⚠ `verified` sirf tab lagta hai jab Judge.me khud `data-verified-buyer="true"`
   kehta ho. Abhi store ke saare reviews Amazon imports hain (false), isliye wo
   line nahi dikhegi — jhooth chhapne se behtar hai.

   Haath se maintain hoti hai (generated nahi).
   ============================================================================ */
(function () {
  var HOST = document.querySelector('[data-da-reviews]');
  if (!HOST) return;

  var STAR = '★★★★★';
  var EMPTY_TEXT = 'Be the first to write a review';

  /* ==========================================================================
     EK SE ZYADA PAGE (owner, 6 Aug 2026: "All me aur reviews dikhao agar hain")
     --------------------------------------------------------------------------
     Judge.me ek baar me sirf 5 review DOM me rakhta hai, chahe total 102 hon
     (naapa: `data-number-of-reviews="102"`, par `.jdgm-rev` sirf 5, aur
     pagination me 21 page). Isliye "All" par review column FAQ se chhota reh
     jaata tha aur neeche jagah bach jaati thi.

     ⚠ Judge.me agla page LAKAR PURANE KO HATA DETA HAI — jodta nahi. Live
     jaancha: page 2 dabate hi authors poore badal gaye (Sudha/Sourabh/... ->
     Sumanta/Varsha/...). Isliye hum khud `COLLECTED` me jama karte hain, warna
     har page ke saath pichhle reviews gayab ho jaate.

     ⚠ EXTRA_PAGES jaan-boojh ke chhota hai. 21 page kheenchne ka matlab 20
     extra AJAX call har PDP load par — wo store ke liye bhaari hai aur Judge.me
     ko bhi. 2 extra page = 15 review, jo sabse lambi FAQ bharne aur scroll dene
     ke liye kaafi hai. Zaroorat pade to badhana, par soch samajh kar.
     ========================================================================== */
  var EXTRA_PAGES = 2;

  var COLLECTED = [];
  var SEEN = Object.create(null);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function txt(root, sel) {
    var e = root.querySelector(sel);
    return e ? e.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* Judge.me "28/04/26" deta hai; mockup "28 Apr 2026" jaisa dikhata hai. */
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function niceDate(s) {
    var m = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/.exec(s || '');
    if (!m) return s || '';
    var d = +m[1], mo = +m[2] - 1, y = m[3].length === 2 ? '20' + m[3] : m[3];
    if (mo < 0 || mo > 11) return s;
    return d + ' ' + MON[mo] + ' ' + y;
  }

  function readReviews() {
    return Array.prototype.map.call(document.querySelectorAll('.jdgm-rev'), function (r) {
      var ratingEl = r.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? parseInt(ratingEl.getAttribute('data-score'), 10) : 5;
      var pics = Array.prototype.map.call(
        r.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__pics img'),
        function (i) { return i.getAttribute('data-src') || i.src; }
      ).filter(Boolean);
      return {
        author: txt(r, '.jdgm-rev__author'),
        date: niceDate(txt(r, '.jdgm-rev__timestamp')),
        title: txt(r, '.jdgm-rev__title'),
        body: txt(r, '.jdgm-rev__body'),
        score: isNaN(score) ? 5 : score,
        verified: r.getAttribute('data-verified-buyer') === 'true',
        pics: pics,
      };
    }).filter(function (v) { return v.body || v.title; });
  }

  /* ⚠ Key me body bhi hai. Sirf author par dedupe karte to ek hi naam ke do
     alag review (live dikhe: page 2 par "Nesha" do baar) ek maan liye jaate. */
  function keyOf(v) {
    return (v.author || '') + '|' + (v.title || '') + '|' + (v.body || '').slice(0, 80);
  }

  function collect() {
    var added = 0;
    readReviews().forEach(function (v) {
      var k = keyOf(v);
      if (SEEN[k]) return;
      SEEN[k] = 1;
      COLLECTED.push(v);
      added++;
    });
    return added;
  }

  function card(v) {
    var stars = STAR.slice(0, v.score) + '☆☆☆☆☆'.slice(0, 5 - v.score);
    var verified = v.verified
      ? '<span class="rverif"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="m20 6-11 11-5-5"/></svg>Verified purchase</span>'
      : '';
    var ugc = v.pics.length
      ? '<div class="ugc">' + v.pics.map(function (src) {
          return '<img src="' + esc(src) + '" alt="Buyer photo from ' + esc(v.author) +
                 '" width="200" height="200" loading="lazy" decoding="async">';
        }).join('') + '</div>'
      : '';
    return '<div class="rev">' +
      '<span class="rbought">' + verified + '</span>' +
      '<div class="rstars">' + stars + '</div>' +
      (v.title ? '<h3 class="revh">' + esc(v.title) + '</h3>' : '') +
      '<p>' + esc(v.body) + '</p>' +
      ugc +
      '<div class="rwho">' + esc(v.author) + '<small>' + esc(v.date) + '</small></div>' +
      '</div>';
  }

  /* Widget ko aankhon se hatao — DOM me rehne do.
     CSS se ye kaam nahi hota: Judge.me ki stylesheet cross-origin hai aur usme
     koi bhaari rule hai jo hamare `display:none` ko haraa deta hai (naapa gaya).
     Inline style stylesheet rules se upar hota hai, isliye yahan se. */
  function hideWidget(hide) {
    var w = document.querySelector('.jdgm-rev-widg');
    if (w) w.style.display = hide ? 'none' : '';

    /* Sirf widget chhupane se uska Shopify SECTION wrapper reh jaata tha —
       `.page-width` ka padding aur background page ke aakhir me ek khali
       rounded box ban ke dikhta tha. Isliye poore section ko chhupate hain.
       DOM me phir bhi rehta hai, to Judge.me ka JS, uska form aur uska
       JSON-LD sab pehle ki tarah chalte hain. */
    var sec = w && w.closest('.shopify-section');
    if (sec) sec.style.display = hide ? 'none' : '';

    return w;
  }

  function render() {
    collect();
    if (!COLLECTED.length) return false;
    HOST.innerHTML = COLLECTED.map(card).join('');
    hideWidget(true);

    /* summary line
       ⚠ Pehle ye loaded reviews se banti thi — aur unme sirf PEHLA PAGE aata
       hai. Is product par wo 5 hai jabki asli total 102 hai, to line "from 5
       reviews" bolti thi.

       Judge.me apna asli aggregate khud `.jdgm-rev-widg` par deta hai:
         data-number-of-reviews="102"  data-average-rating="5.00"
       Wahi authority hai — usko pehle padho, aur na mile tabhi list par giro. */
    var sum = document.querySelector('[data-da-review-summary]');
    if (sum) {
      sum.dataset.daFilled = '1';

      var widg     = document.querySelector('.jdgm-rev-widg');
      var totAttr  = parseInt(widg && widg.getAttribute('data-number-of-reviews'), 10);
      var avgAttr  = parseFloat(widg && widg.getAttribute('data-average-rating'));

      var count = (isFinite(totAttr) && totAttr > 0) ? totAttr : COLLECTED.length;
      var avg   = (isFinite(avgAttr) && avgAttr > 0)
        ? avgAttr
        : COLLECTED.reduce(function (a, v) { return a + v.score; }, 0) / COLLECTED.length;

      /* ⚠ Photo-count sirf loaded reviews se hi ginn sakte hain. Agar sab reviews
         DOM me nahi hain to "N with buyer photos" ek JHOOTHA aankda ban jaata hai
         (15 me se 2 dikhte hain, par 102 me kitne hain pata nahi). Isliye ye line
         tabhi dikhti hai jab poora set loaded ho. */
      var withPics  = COLLECTED.filter(function (v) { return v.pics.length; }).length;
      var picsKnown = count === COLLECTED.length;

      /* aadha sitara: `.st` plain ★★★★★ tha, isliye 4.6 bhi paanch bhare dikhta tha */
      var pct = Math.max(0, Math.min(100, (avg / 5) * 100));

      sum.innerHTML = '<b class="n">' + avg.toFixed(1) + '</b>' +
        /* aria-hidden: fgs aur bgs dono me ★★★★★ hai (ek doosre ke upar layered),
           to screen reader inhe DAS sitare padhta. Number `.n` pehle hi bol deta hai. */
        '<span class="st" aria-hidden="true"><span class="sv">' +
          '<span class="bgs">' + STAR + '</span>' +
          '<span class="fgs" style="width:' + pct.toFixed(1) + '%">' + STAR + '</span>' +
        '</span></span>' +
        '<span>from ' + count + ' review' + (count === 1 ? '' : 's') +
        (picsKnown && withPics ? ' &nbsp;·&nbsp; ' + withPics + ' with buyer photos' : '') + '</span>';
    }
    return true;
  }

  /* ---- Judge.me ke agle page laao ---------------------------------------
     ⚠ Ye tabhi chalta hai jab pehla page render ho chuka ho. Pagination tabhi
     DOM me aati hai jab widget apne reviews bana chuka hota hai.

     Har page click ke baad hum wait karte hain ki list SACH ME badli ya nahi —
     pehle `.jdgm-rev` ke author+title se. Judge.me AJAX se list badalta hai,
     to bina intezaar ke scrape karne par wahi purane 5 dobara mil jaate. */
  function firstKey() {
    var r = document.querySelector('.jdgm-rev');
    if (!r) return '';
    return txt(r, '.jdgm-rev__author') + '|' + txt(r, '.jdgm-rev__title');
  }

  function loadMorePages(left) {
    if (left <= 0) return;

    var next = document.querySelector('.jdgm-paginate__next-page');
    if (!next) return;

    var before = firstKey();
    next.click();

    var tries = 0;
    (function wait() {
      if (firstKey() && firstKey() !== before) {
        var added = collect();
        if (added) render();
        /* kuch naya na mila to aage ke page bhi bekaar — ruk jao */
        if (added) loadMorePages(left - 1);
        return;
      }
      if (++tries > 24) return;      /* page aaya hi nahi — chhod do, jitne hain wahi sahi */
      setTimeout(wait, 250);
    })();
  }

  /* ⚠ Widget ko SHURU se chhupao, sirf tab nahi jab reviews mil jaayein.
     Pehle `hideWidget(true)` sirf `render()` ke andar chalta tha, yani jis
     product par ek bhi review nahi hai wahan Judge.me ka apna "Customer Reviews /
     Be the first to write a review" panel page ke neeche ALAG se dikhta rehta
     tha — aur upar hamara reviews section bhi. Owner ko ek hi chahiye. */
  hideWidget(true);

  /* Judge.me async load hota hai — jab tak reviews na aayein, dekhte raho. */
  var tries = 0;
  (function wait() {
    if (render()) {
      loadMorePages(EXTRA_PAGES);
      return;
    }
    if (++tries > 40) {
      /* Sach me koi review nahi hai. Hamara section apni khali-state ke saath
         khada rehta hai (heading + Write a review button). */
      var sum = document.querySelector('[data-da-review-summary]');
      if (sum && !sum.dataset.daFilled) sum.innerHTML = '<span>' + esc(EMPTY_TEXT) + '</span>';
      return;
    }
    setTimeout(wait, 500);
  })();

  /* ---- Write a review -> Judge.me ka form, hamare modal me ----------------
     ⚠ Pehle ye poora widget un-hide karke uspar scroll kar deta tha — isliye
     Judge.me ka apna "Customer Reviews" panel page par khul jaata tha.

     APNA form banana yahan MUMKIN NAHI hai: Judge.me me review post karne ke
     liye unka private API token chahiye, aur wo client-side JS me rakha hi nahi
     ja sakta. Isliye Judge.me ka apna form hi chalta hai, bas use hamare modal
     me daal ke mockup jaisa dikha dete hain. */
  var modal = null, restore = null;

  /* Judge.me ke kuch label CSS se theek nahi ho sakte, kyunki dikkat unke TEXT me
     hai, style me nahi:
       · "Display name (displayed publicly like [John Smith])" — beech me ek
         naam-format wala <select> baithta hai. Select ko CSS se chhupa diya, par
         "(" aur ")" text nodes bache reh jaate the.
       · "Picture/Video (optional)" — is store par sirf tasveerein chalti hain. */
  function tidyLabels(form) {
    var LABELS = [
      { match: /display name/i,          text: 'Name' },
      { match: /picture\s*\/?\s*video/i, text: 'Add a photo (optional)' }
    ];

    var nameInput = form.querySelector('input[name="reviewer_name"]');
    if (nameInput) nameInput.setAttribute('placeholder', 'Your name');

    var nodes = form.querySelectorAll('label, .jdgm-form__inline-label');
    Array.prototype.forEach.call(nodes, function (el) {
      /* jis label ke andar koi input/select hai use mat chhedo */
      if (el.querySelector('input, textarea')) return;
      var t = (el.textContent || '').trim();
      for (var i = 0; i < LABELS.length; i++) {
        if (LABELS[i].match.test(t)) { el.textContent = LABELS[i].text; return; }
      }
    });
  }

  function buildModal() {
    var m = document.createElement('div');
    m.className = 'dajm';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Write a review');
    m.innerHTML =
      '<div class="dajm__veil" data-dajm-close></div>' +
      '<div class="dajm__panel">' +
        '<button type="button" class="dajm__x" data-dajm-close aria-label="Close">&times;</button>' +
        '<p class="dajm__eyebrow">Your experience</p>' +
        '<h3 class="dajm__h">Write a review</h3>' +
        '<div class="dajm__body"></div>' +
      '</div>';
    document.body.appendChild(m);
    return m;
  }

  function closeModal() {
    if (!modal) return;
    /* form ko apni asli jagah (widget ke andar) wapas rakho, warna Judge.me ka
       apna JS use dobara nahi dhoondh payega */
    if (restore && restore.el) {
      var parent = restore.parent && restore.parent.isConnected ? restore.parent : null;
      if (parent) {
        var next = restore.next && restore.next.parentElement === parent ? restore.next : null;
        parent.insertBefore(restore.el, next);
      }
      hideWidget(true);
    }
    restore = null;
    modal.classList.remove('on');
    document.documentElement.classList.remove('dajm-lock');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dajm-close]')) { closeModal(); return; }

    var btn = e.target.closest('[data-da-write-review]');
    if (!btn) return;
    e.preventDefault();

    var widget = hideWidget(false);
    if (!widget) return;

    if (!modal) modal = buildModal();

    /* ⚠ WIDGET KO MODAL ME MAT LE JAO — do baar aazma ke dekh liya, form banta hi
       nahi tha. Judge.me apna form lazily banata hai aur use `.jdgm-row-actions`
       ke andar daalta hai; widget ko uthate hi wo insert gir jaata tha.

       Jo raasta sach me chalta hai: widget ko apni jagah par KHULA rehne do,
       Judge.me ka link dabao, form ban jaane do — aur uske BAAD sirf form ko
       modal me le aao. */
    modal.classList.add('on');
    document.documentElement.classList.add('dajm-lock');
    modal.querySelector('.dajm__body').innerHTML = '<p class="dajm__wait">Loading…</p>';

    var link = widget.querySelector('.jdgm-write-rev-link');
    if (link) link.click();

    var t2 = 0;
    (function grabForm() {
      var form = document.querySelector('.jdgm-form-wrapper, .jdgm-form');

      if (form && !modal.contains(form)) {
        restore = { el: form, parent: form.parentElement, next: form.nextSibling, widget: widget };
        var body = modal.querySelector('.dajm__body');
        body.innerHTML = '';
        body.appendChild(form);
        hideWidget(true);           /* widget wapas nazron se hat jaaye */
        tidyLabels(form);
        var first = form.querySelector('input[name="review_title"], input, textarea');
        if (first) { try { first.focus(); } catch (e2) {} }
        return;
      }

      if (++t2 < 24) {
        /* pehli click kabhi-kabhi tab lagti hai jab Judge.me ka JS taiyar nahi */
        if (t2 % 4 === 0 && link) link.click();
        setTimeout(grabForm, 250);
        return;
      }

      modal.querySelector('.dajm__body').innerHTML =
        '<p class="dajm__wait">Review form could not load. Please refresh and try again.</p>';
    })();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('on')) closeModal();
  });
})();
